import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProjectionMobDot } from './ProjectionMobDot';

const rootStyles = {
  position: 'absolute',
  right: '172px',
  bottom: '496px',
  display: 'flex',
  flexDirection: 'row',
  marginRight: `${-54}px`,
};

class ProjectionMobPagination extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(_event, index) {
    this.props.onChangeIndex(index);
  }

  render() {
    const { index, dots } = this.props;
    const children = [];
    for (let i = 0; i < dots; i++) {
      children.push(
        <ProjectionMobDot
          key={i}
          index={i}
          active={i === index}
          onClick={this.handleClick}
        />
      );
    }
    return (
      <div className="demo-pagination" style={rootStyles}>
        {children}
      </div>
    );
  }
}

ProjectionMobPagination.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
};

export default ProjectionMobPagination;
